"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.products = void 0;
var products = {
  auth: {
    sp: 'csweb',
    type: 'CSWEB'
  },
  onvio: {
    sp: 'onvio',
    type: 'ONVIO'
  }
};
exports.products = products;
